import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { messageFormat } from '@clubmed/utils';
import { ImmersiveSlideShowItem } from './item/ImmersiveSlideShowItem';
import { ImmersiveSlideShowLarge } from './large/ImmersiveSlideShowLarge';
import { ImmersiveSlideShowNarrow } from './narrow/ImmersiveSlideShowNarrow';
type Props = {
  className?: string;
  immersiveSize?: ImmersiveSizeProps;
  media: Array<string>;
  nextLabel?: string;
  pictureAltLabel?: string;
  previousLabel?: string;
  isPaginationDisabled?: boolean;
  controlsTheme?: string;
};
export const ImmersiveSlideShow = ({
  immersiveSize = 'large',
  media = [],
  nextLabel,
  pictureAltLabel = '',
  previousLabel,
  ...rest
}: Props) => {
  const { isDesktop } = useResponsive();

  if (!media.length) {
    return null;
  }

  const items = media.map((src, idx) => (
    <ImmersiveSlideShowItem
      {...rest}
      alt={messageFormat(pictureAltLabel).format({
        nb: idx + 1,
      })}
      immersiveSize={immersiveSize}
      isImmersive={isDesktop}
      key={src}
      src={src}
    />
  ));
  const { controlsTheme, isPaginationDisabled } = rest;
  return isDesktop ? (
    <ImmersiveSlideShowLarge
      items={items}
      controlsTheme={controlsTheme}
      isPaginationDisabled={isPaginationDisabled}
      immersiveSize={immersiveSize}
      nextLabel={nextLabel}
      previousLabel={previousLabel}
    />
  ) : (
    <ImmersiveSlideShowNarrow
      items={items}
      controlsTheme={controlsTheme}
      isPaginationDisabled={isPaginationDisabled}
      nextLabel={nextLabel}
      previousLabel={previousLabel}
    />
  );
};
